﻿import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import AptitudesTableHead from "./AptitudesTableHead";
import AptitudesTableBody from "./AptitudesTableBody";
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import DealersForm from "./AptitudesForm/AptitudesForm";
import classes from "../maintainers.module.scss";

import { useAptitudesPaginate, useMutateAptitude, useMutateDeleteAptitud, useMutateGroup } from "@/hooks/maintainers/aptitudes";
import { base_list } from "./aptitudes.constants";

const Aptitudes = () => {
	const { addToast } = useToasts();
	const { search } = useSelector((state) => state.auth.filter);
	const { option } = useParams();
	const navigate = useNavigate();

	const [base, setBase] = useState({ ...base_list });
	const [showDelete, setShowDelete] = useState(false);
	const [selected, setSelected] = useState("");
	const [showGroup, setShowGroup] = useState(false);
	const [groupAptitudes, setGroupAptitudes] = useState([]);

	const { data, isLoading, isFetching } = useAptitudesPaginate({
		...base,
		search,
	});

	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateAptitude({
		...base,
		search,
	});

	const { mutate: mutateGroup, isLoading: isLoadingGroup } = useMutateGroup({
		...base,
		search,
	});

	const { mutate: mutateDelete, isLoading: isLoadingDelete } = useMutateDeleteAptitud({
		...base,
		search,
	});

	const { aptitudes: list } = data ? data : {};
	const { data: aptitudes, last_page, total, from, to } = list ? list : {};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		mutateDelete(
			{ ...base, search, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowDelete(false);
					addToast("Aptitud eliminada correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const confirmSave = (data) => {
		mutateSave(
			{ ...base, search, params: { ...data } },
			{
				onSuccess: () => {
					addToast("Aptitud guardada correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	const handelGroup = () => {
		setShowGroup(true);
	};

	const confirmGroup = () => {
		setShowGroup(false);

		mutateGroup(
			{ ...base, search, params: { ...groupAptitudes } },
			{
				onSuccess: () => {
					const baseId = groupAptitudes[0].id;

					setGroupAptitudes([]);
					addToast("Aptitudes agrupadas correctamente", {
						appearance: "success",
					});

					navigate(`/mantenedores/aptitudes/editar/${baseId}`);
				},
			},
		);
	};

	if (isLoading || isLoadingDelete || isLoadingGroup) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Aptitudes"
				button={true}
				button_text={"Nueva Aptitud"}
				action={() => navigate("/mantenedores/aptitudes/crear")}
				back_url={"/mantenedores"}
				isFetching={isFetching}
			/>
			<Row className={` ${classes.main_row}`}>
				<Col md={12} className={classes.main_col}>
					{groupAptitudes.length > 0 && (
						<Row className={`${classes.header} ${groupAptitudes.length > 0 && classes.have_action}`}>
							<Col md={1} className={classes.col_base_action}>
								<div className={classes.hr_vertical}></div>
								<div className={classes.text}>Seleccione una opción</div>
							</Col>
							<Col md={6} className={classes.col_action}>
								<div className={classes.action} onClick={() => handelGroup()}>
									Agrupar Aptitudes
								</div>
							</Col>
						</Row>
					)}
					<Row className={classes.table}>
						<div className={classes.table_div}>
							<Table className={classes.table_desktop}>
								<AptitudesTableHead order={base.order} setOrder={setOrder} orderType={base.orderType} setOrderType={setOrderType} />

								<AptitudesTableBody
									aptitudes={aptitudes}
									handleDelete={handleDelete}
									groupAptitudes={groupAptitudes}
									setGroupAptitudes={setGroupAptitudes}
								/>
							</Table>
						</div>
					</Row>

					<BasePagination
						page={base.page}
						paginate={base.paginate}
						last_page={last_page}
						quantity={total}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			<BasicConfirm
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={confirmDelete}
				showValidation={true}
				textValidation={"eliminar aptitud"}
			/>

			<BasicConfirm
				showConfirm={showGroup}
				setShowConfirm={setShowGroup}
				handleAction={confirmGroup}
				message={"¿Estas seguro que deseas agrupar estas aptitudes?"}
				subMessage={`Al realizar esta accion se agruparan las aptitudes seleccionadas a ${groupAptitudes.length > 0 ? groupAptitudes[0].name : "Ninguna"}`}
				showValidation={true}
				textValidation={"juntar aptitudes"}
			/>

			{option && <DealersForm confirmSave={confirmSave} isLoadingSave={isLoadingSave} />}
		</>
	);
};

export default Aptitudes;
